import styles from './CalculationsBar.module.css'
import LoadingSpinner from '../../StatusIndicators/LoadingSpinner'
import { UnableToLoadData } from '../../SystemState/ErrorManagement/UnableToLoadData/UnableToLoadData'
import { useProjectReportSummary } from './customHooks/useProjectReportSummary'
import { useProjektprognosEditingContext } from '../context/ProjektprognosEditingContext'
import { ReportCommentField } from '../ReportComment/ReportCommentField'

const CalculationsBar = () => {
  const {
    isLoading,
    error,
    content: projectReportSummary,
  } = useProjectReportSummary()

  const { selectedPeriodReport } = useProjektprognosEditingContext()

  if (isLoading) {
    return (
      <div className={styles.loadingSpinnerContainer}>
        <LoadingSpinner />
      </div>
    )
  }

  if (error) {
    return (
      <div className={styles.calculationsBarContainer}>
        <UnableToLoadData message={'Grunduppgifter kunde ej laddas'} />
      </div>
    )
  }

  return (
    <div className={styles.calculationsBarWrapper}>
      <div className={styles.calculationsBarContainer}>
        {projectReportSummary}
      </div>
      <ReportCommentField periodReport={selectedPeriodReport} />
    </div>
  )
}

export default CalculationsBar
